<div class="ap-card">
    <div class="ap-card__wrapper">
        @if (iconName() || title()) {
            <div class="ap-card__header" data-testid="header">
                @if (title()) {
                    <div class="ap-card__title" data-testid="title">{{ title() }}</div>
                }
                @if (iconName()) {
                    <span class="ap-card__icon">
                        <ap-action-icon (onClick)="onIconClick()" [ariaLabel]="iconAriaLabel()" data-testid="header-icon">
                            <ap-icon size="medium" [name]="iconName()"></ap-icon>
                        </ap-action-icon>
                    </span>
                }
            </div>
        }
        <div class="ap-card__body" data-testid="body">
            <ng-content></ng-content>
        </div>
    </div>
</div>
